import {
  Button,
  Card,
  Container,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
interface CustomProps {
  isOpen: boolean;
  setOpen: any;
}

const CreateCampaignBox = (props: CustomProps) => {
  const theme = useTheme();

  return (
    <Card sx={{ p: 4 }}>
      <Stack alignItems="center" justifyContent="center" textAlign="center">
        <Typography
          variant="h5"
          color={theme.palette.primary.main}
          gutterBottom
        >
          No Campaigns
        </Typography>
        <Container maxWidth="sm">
          <Typography variant="body2">
            It looks like you haven't created any campaigns yet. Start your
            first campaign to see them listed here and begin engaging with your
            audience effectively.
          </Typography>
        </Container>
        <Button
          color="primary"
          onClick={() => props.setOpen(true)}
          variant="contained"
          size="small"
          sx={{ mt: 2 }}
        >
          Create Campaign
        </Button>
      </Stack>
    </Card>
  );
};

export default CreateCampaignBox;
